export { default as GDMPhoneMask } from './GDMPhoneMask';

export type { GDMPhoneMaskComponent } from './GDMPhoneMask.type';
